export default __webpack_public_path__ + "static/media/project2.9e78cfee.png";